import { useLocation, matchRoutes } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../store";
import { ESliceAuth } from '../../store/slices/authSlice'
import { useEffect } from "react";
import { routes } from "../../routes/routeObject"
import { setMenuStore } from "../../store/slices/menuSlice"


export default function useSetCurrentPermission(): void {
    const location = useLocation()
    const dispatch = useAppDispatch()
    const { permission: permissionList } = useAppSelector(state => state[ESliceAuth.AuthInfo])

    useEffect(() => {
        // setCurrent menu code, permisson
        const objPathParents: Array<any> = matchRoutes(routes, location.pathname) || []
        const indexOfObjPathParents = objPathParents?.findIndex(route => route.pathname === location.pathname)
        let code: string = objPathParents[indexOfObjPathParents]?.route?.code || ""

        // เช็คถ้าไม่มี code และไม่ใช่หัว parents
        if (!code && indexOfObjPathParents > 1) {
            // ถ้าไม่มี code ให้ไปดึงตัวแม่
            objPathParents.filter((o, index) => index < indexOfObjPathParents).reverse().every(objPath => {
                if (objPath.route?.code) {
                    code = objPath.route.code
                    return false
                }
                return true
            })
        }

        // validate permission menu
        const permission = {
            create: false,
            update: false,
            delete: false,
            approve: false,
            read: false,
        }
        if (permissionList?.length > 0) {
            const currentItem = permissionList.find((o: any) => o.roles_code === code)

            if (currentItem) {
                permission.create = !!(currentItem.create === 1)
                permission.update = !!(currentItem.update === 1)
                permission.delete = !!(currentItem.delete === 1)
                permission.approve = !!(currentItem.approve === 1)
                permission.read = !!(currentItem.read === 1)
            }
        }
        dispatch(setMenuStore({ code, ...permission }))
    }, [location.pathname, permissionList, dispatch])
}


